module.exports = __webpack_public_path__ + "assets/img/vue_template_v_model.f92166af.jpg";